module.exports = __webpack_public_path__ + "static/img/dashboardBg.c61f6e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/dashboard/dashboardBg.png
// module id = DrEN
// module chunks = 8